module.exports = __webpack_public_path__ + "img/conclusion1.60509dcb.svg";